import composerTag from './Composer/index';

const tags = {
  composer: composerTag
};

export default tags;
